import { SubLayout } from '@/components/layouts'
const routes = {
  path: '/mine',
  redirect: '/mine/index',
  component: SubLayout,
  children: [
    {
      path: 'changePass',
      name: 'changePass',
      meta: {
        title: '设置密码'
      },
      component: () => import('@/views/mine/ChangePass')
    }
  ]
}

export default routes
